// 页数相关的属性方法
let pageMixin = {
  data () {
    return {
      page: 1,
      pagesize: 50,
      totalCount: 0
    }
  },
  methods: {
    handleSizeChange (pagesize) {
      this.pagesize = pagesize
      this.page = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.page = page
      this.getList()
    }
  },
  created () {
    this.page = this.$route.query.page * 1 || 1
    this.pagesize = this.$route.query.pagesize * 1 || 50
  }
}

export default pageMixin
